<template>
  <v-input
      hide-details
      readonly>
    <template #default>
      <span class="preview-text">{{ model }}</span>
    </template>
    <template #append>
      <el-popover
          v-if="readonly"
          placement="left"
          trigger="click"
          width="600"
          :content="value"
          @show="handleViewOpened"
          @hide="handleViewClosed">
        <template slot="default">
          <div class="full-text">{{ model }}</div>
        </template>
        <template slot="reference">
          <v-btn x-small icon :class="{selected: popupOpened}">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
      </el-popover>

      <el-popover
          v-else
          ref="popoverEdit"
          placement="left"
          trigger="click"
          width="600"
          :popper-options="{removeOnDestroy: true}"
          :append-to-body="false"
          @show="handleEditOpened"
          @hide="handleEditClosed"
          @created="handlePopupCreated">
        <template slot="default">
          <v-textarea
              ref="textarea"
              v-model="model"
              auto-grow
              hide-details
              outlined>
          </v-textarea>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="primary" @click="handleEditClose(false)">キャンセル</v-btn>
            <v-btn depressed color="primary" @click="handleEditClose(true)">OK</v-btn>
          </v-card-actions>
        </template>
        <template slot="reference">
          <v-btn icon x-small :class="{selected: popupOpened}">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </el-popover>
    </template>
  </v-input>
</template>

<script>
export default {
  name: 'DescriptionInput',
  props: {
    value: String,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: this.value,
      popovers: [],
      popupOpened: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      const textareaEl = this.$el.querySelector('textarea');
      if(textareaEl) {
        textareaEl.addEventListener('keydown', this.handleKeyDown);
      }
    });
  },
  beforeDestroy() {
    for(const popover of this.popovers) {
      popover.doClose();
      popover.doDestroy();
    }
  },
  methods: {
    handleEditOpened() {
      this.$nextTick(() => {
        const textarea = this.$refs.textarea;
        textarea.calculateInputHeight();
        textarea.focus();
      });
      this.popupOpened = true;
    },
    handleEditClose(apply) {
      if (apply) {
        this.$emit('input', this.model);
        this.$emit('change', this.model);
      }
      this.$refs.popoverEdit.doClose();
    },
    handleEditClosed() {
      this.popupOpened = false;
    },
    handleViewOpened() {
      this.popupOpened = true;
    },
    handleViewClosed() {
      this.popupOpened = false;
    },
    handleKeyDown(e) {
      if (e.shiftKey && e.keyCode === 13) {
        e.preventDefault();
        this.handleEditClose(true);
      }
    },
    handlePopupCreated(popover) {
      document.querySelector('#app').appendChild(popover.popperElm);
      this.popovers.push(popover);
    }
  }
}
</script>

<style lang="scss" scoped>
.v-input {
  padding: 5px 12px;

  .preview-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 28px;
  }
}

.full-text {
  white-space: pre-wrap;
}

.v-btn.selected {
  background-color: #1976d2;
  color: white !important;
}
</style>
